import axios from 'axios';

const baseDomain = process.env.VUE_APP_GRAFFITTI_API;

export default axios.create({
    baseURL: baseDomain,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
})
